var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClimateAndGreenIssues = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Global-Warming-High-Temperature--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Global Warming High Temperature Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0a9.34 9.34 0 0 0 -4.31 1.06 1 1 0 1 0 0.93 1.77 7.35 7.35 0 0 1 2.22 -0.74 0.48 0.48 0 0 1 0.38 0.1 0.46 0.46 0 0 1 0.19 0.34 1.48 1.48 0 0 0 0.78 1.13l1.76 1a0.49 0.49 0 0 1 0.2 0.67l-0.3 0.54A1.51 1.51 0 0 0 17.66 8l1 0.18a1.18 1.18 0 0 0 0.26 0 1.49 1.49 0 0 0 1.32 -0.78l0.64 -1.18a0.25 0.25 0 0 1 0.23 -0.13 0.25 0.25 0 0 1 0.22 0.15 7.25 7.25 0 0 1 -4.33 9.9 0.49 0.49 0 0 1 -0.5 -0.11l-2.39 -2.26a0.82 0.82 0 0 1 -0.15 -1 1.5 1.5 0 0 0 0.12 -1.14 1.52 1.52 0 0 0 -0.72 -0.89l-1.76 -1a1.46 1.46 0 0 0 -1.14 -0.11 0.63 0.63 0 0 0 -0.46 0.61v4.22a1 1 0 0 0 0.2 0.6 6.31 6.31 0 0 1 1.09 2.24 1 1 0 0 0 0.66 0.7 9.25 9.25 0 1 0 2.8 -18Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.06V3.5a3.5 3.5 0 0 0 -7 0v11.56a1 1 0 0 1 -0.25 0.66A5 5 0 1 0 10 19a5 5 0 0 0 -1.25 -3.28 1 1 0 0 1 -0.25 -0.66ZM5 21a2 2 0 0 1 -1.2 -3.6 0.48 0.48 0 0 0 0.2 -0.4V8.5a1 1 0 0 1 2 0V17a0.48 0.48 0 0 0 0.2 0.4A2 2 0 0 1 5 21Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClimateAndGreenIssues);
export default ForwardRef;